import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'rs-error-info',
  templateUrl: './error-info.component.html',
  styleUrls: ['./error-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorInfoComponent {
  @Input() showClose: boolean = true;
  @Output() closed = new EventEmitter<void>();

  public close(): void {
    this.closed.emit();
  }
}
